export default __webpack_public_path__ + "static/media/RetailBanking.fdb51813.png";